<template>
  <div>
      <div v-if="page == 1">
      <el-button style="float: left;" @click="drawer = true">查询</el-button>
  
              <el-drawer
                title="查询条件"
              style="height: 200%;"
                :visible.sync="drawer"
                :direction="direction">
                    <el-form :inline="true"  class="demo-form-inline">
                      <el-form-item label="审核人">
                        <el-input  v-model.trim="SelectFrom.checkUserId" :value="ManagerUser"  placeholder="根据使用人姓名查询">
                            <el-button
                              size="mini"
                               style="padding-right:10px"
                               slot="suffix"
                               type="text"
                              @click="dialogManager = true">选择</el-button> </el-input>
                              <el-dialog title="选择查询人员" :visible.sync="dialogManager" append-to-body width="35%">
                                <el-tree
                                  class ="TreeBlock"
                                  :data="MangerData"
                                  :filter-node-method="filterNode"
                                  node-key="id"
                                  @node-click="TreeMangerClick"
                                  ref="tree"
                                  :props="defaultProps"
                                  default-expand-all:false
                                  :expand-on-click-node="false">
                                  <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <span>{{ node.label }}</span>
                                  </span>
                                </el-tree>
                                <div slot="footer" class="dialog-footer">
                                  <el-button @click="dialogManager = false">取 消</el-button>
                                  <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                                </div>
                              </el-dialog>
                      </el-form-item>
                <el-form-item label="盘点时间">
                  <el-input  style="width: 200px;"
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model.trim="SelectFrom.startDate" 
                  placeholder="请选中开始时间"></el-input>
                  <el-input  style="width: 200px;"  
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model.trim="SelectFrom.endDate" 
                  placeholder="请选中结束时间"></el-input>
                </el-form-item>
                    
                <el-form-item label="盘点单状态">
                      <el-select  v-model.trim="SelectFrom.checkState" placeholder="是否为资产状态">
                        <el-option label="进行中" :value='1'></el-option>
                        <el-option label="待审核" :value='2'></el-option>
                        <el-option label="已完成" :value='3'></el-option>
                        <el-option label="已终止" :value='4'></el-option>
                        <el-option label="已驳回" :value='5'></el-option>
                      </el-select>
                </el-form-item>
                    </el-form>
                  <el-button type="primary" @click="showData(1)">查询</el-button>
                  <el-button type="primary" @click="resetForm('SelectFrom')">重置</el-button>
              </el-drawer>
            
            
            
            
              <el-table
                  :data="tableData"
                  height="500"
                  @row-click="handdle"
                  border
                  style="width: 100%">
  
  
                   <!-- <router-link to="/detail?id=001&title=消息001"> 消息001</router-link> -->
                  <router-link to="/index">
                    <el-table-column
                      prop="checkName"
                      label="盘点单名称"
                      width="180">
                    </el-table-column>
                  </router-link>
  
  
  
                  <el-table-column
                    prop="checkState"
                    label="盘点状态"
                    width="180">
  
  
                    <template slot-scope="scope">
                      <el-tag
                      :type="scope.row.checkState == 1?''
                      :(scope.row.checkState==2?'success'
                      :(scope.row.checkState==3?'danger'
                      :(scope.row.checkState==4?'info':'warning')))"
                      effect="dark">
                        <div v-if="scope.row.checkState == 1">进行中</div>
                        <div v-if="scope.row.checkState == 2">待审核</div>
                        <div v-if="scope.row.checkState == 3">已完成</div>
                        <div v-if="scope.row.checkState == 4">已终止</div>
                        <div v-if="scope.row.checkState == 5">已驳回</div>
                      </el-tag>
                    </template>
  
  
  
  
                  </el-table-column>
                  <el-table-column
                    prop="checkerName"
                    label="审核人姓名">
                  </el-table-column>
                  <el-table-column
                    prop="createName"
                    label="创建人姓名">
                  </el-table-column>
                  <el-table-column
                    prop="unitName"
                    label="公司名称">
                  </el-table-column>
                </el-table>
          
        
        <div class="block">
            <el-pagination
              @size-change="showData"
              @current-change="showData"
              :current-page.sync="currentPage"
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="pageSize">
            </el-pagination>
          </div>
        
        
          
          
  
        </div>
        <div v-if="page == 2">
          <CheckDataDetail></CheckDataDetail>
        </div>
        
    <div v-if="page == 3">
      <CheckErrorData></CheckErrorData>
    </div>				
  
  </div>
  </template>
  
  <script>
    import axios from 'axios'
    import Cookies from "js-cookie";
    import CheckDataDetail from "./CheckDataDetail.vue"
    import CheckErrorData from "./CheckErrorData.vue"
    export default {
       name: 'CheckData',
       components:{
         CheckDataDetail,
       CheckErrorData
       },
       data () {
         return {
         dialogManager:false,
         drawer:false,
             page:1,
             checkId:'',
             taskId:'',
         pageSize:10,
         currentPage:1,
         SelectFrom:{
               checkState:'',
               checkUserId:'',
               startDate:'',
               endDate:''
         },
         defaultProps: {
                  children: 'children',
                  label: 'label'
                },
         direction: 'ttb',
         ManagerUser:'',
         MangerData: [{
           id:'',
           label: '',
           realId:'',
           operator:'',
           children: [{
             id:'',
             label: '',
             realId:'',
             operator:'',
             children: [{
               id:'',
               label: '',
               realId:'',
               operator:'',
             }]
           }]
         }],
             tableData: [{
                      checkId:'',
                      unitId:'',
                      checkName:'',
                      checkUserId:'',
                      checkState:'',
                      createUserId:'',
                      createDate:'',
                      endDate:'',
                      checkerName:'',
                      createName:'',
                      unitName:'',
                    },]
          };
       },
       mounted:function() {
         this.showData();
      this.showMData();
       },
       methods: {
       showMData(){
        var authorization = Cookies.get("Authorization");
         this.axios({
             method: 'GET',
             url: '/public/getUnitTree',
             header:{
              'Authorization':authorization,
               'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               }
           }).then((resp)=>{
            this.MangerData = resp.data.data
           })
       },
       resetForm(formName) {
         Object.assign(this.$data.SelectFrom, this.$options.data().SelectFrom)
         this.ManagerUser =0
         this.showData()
           },
         handdle(row,event,column){
           this.page = 2
           this.checkId = row.checkId
           this.taskId = row.taskId
         },
       handleCurrentChange(val){
             this.showData(val);
       },
       filterNode(value, data) {
               if (!value) return true;
               return data.label.indexOf(value) !== -1;
             },
      TreeMangerClick(data){
          if(data.operator == 1){
            this.ManagerUser = data.realId
            this.SelectFrom.checkUserId = data.label
            this.dialogManager = false
          }else{
            return;
          }
      },
          showData(){
           var authorization = Cookies.get("Authorization");
           var params = {
             checkState:this.SelectFrom.checkState || undefined,
             checkUserId:this.ManagerUser || undefined,
             startDate:this.SelectFrom.startDate || undefined,
             endDate:this.SelectFrom.endDate || undefined,
             currentPage: 1 || val,
             pageSize: this.pageSize,
           }
            this.axios({
                method: 'GET',
                url: '/check/showCheckList',
                params:params,
                header:{
                 'Authorization':authorization,
                  'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  }
              }).then((resp)=>{
               this.tableData=resp.data.data;
               this.pageSize=resp.data.count;
              })
          },
          select(val){
            var authorization = Cookies.get("Authorization");
            var params = {
              currentPage: val || 1 ,
              pageSize: 10,
            }
             this.axios({
                 method: 'GET',
                 url: '/check/showCheckList',
                 params:params,
                 header:{
                  'Authorization':authorization,
                   'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                   }
               }).then((resp)=>{
                this.tableData=resp.data.data;
                this.pageSize=resp.data.count;
               })
          }
       }
     }
  </script>
  
  <style>
  </style>
  
<!-- <template>
<div>
    <div v-if="page == 1">
        <el-container style="margin-top: 2%;">
            <el-table
                :data="tableData"
                height="500"
                @row-click="handdle"
                border
                style="width: 100%">

                <router-link to="/index">
                  <el-table-column
                    prop="checkName"
                    label="盘点单名称"
                    width="180">
                  </el-table-column>
                </router-link>



                <el-table-column
                  prop="checkState"
                  label="盘点状态"
                  width="180">


                  <template slot-scope="scope">
                    <el-tag
                    :type="scope.row.checkState == 1?''
                    :(scope.row.checkState==2?'success'
                    :(scope.row.checkState==3?'info'
                    :(scope.row.checkState==4?'danger':'warning')))"
                    effect="dark">
                      <div v-if="scope.row.checkState == 1">进行中</div>
                      <div v-if="scope.row.checkState == 2">待审核</div>
                      <div v-if="scope.row.checkState == 3">已完成</div>
                      <div v-if="scope.row.checkState == 4">已终止</div>
                      <div v-if="scope.row.checkState == 5">已驳回</div>
                    </el-tag>
                  </template>




                </el-table-column>
                <el-table-column
                  prop="checkerName"
                  label="盘点人姓名">
                </el-table-column>
                <el-table-column
                  prop="createName"
                  label="创建人姓名">
                </el-table-column>
                <el-table-column
                  prop="unitName"
                  label="公司名称">
                </el-table-column>


              </el-table>
        </el-container>

      </div>
      <div v-if="page == 2">
        <CheckDataDetail></CheckDataDetail>
      </div>

</div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import CheckDataDetail from "./CheckDataDetail.vue"
  export default {
     name: 'CheckData',
     components:{
       CheckDataDetail
     },
     data () {
       return {
           page:1,
           checkId:'',
           taskId:'',
           tableData: [{
                    checkId:'',
                    unitId:'',
                    checkName:'',
                    checkUserId:'',
                    checkState:'',
                    createUserId:'',
                    createDate:'',
                    endDate:'',
                    checkerName:'',
                    createName:'',
                    unitName:'',
                  },]
        };
     },
     mounted:function() {
       this.showData();

     },
     methods: {
			 
			 
			 // 将选中的资产任务的数据传给组件
			 // 同时page=2改变页面
       handdle(row,event,column){
         this.page = 2
         this.checkId = row.checkId
         this.taskId = row.taskId
       },
	   // 主要数据展示给tableData
        showData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/check/showCheckList',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.tableData=resp.data.data;
             this.pageSize=resp.data.count;
            })
        },
     }
   }
</script>

<style>
</style> -->



// WEBPACK FOOTER //
// src/components/Check/CheckData.vue